import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import { SelectInfo } from "rc-menu/lib/interface";
import React, { useEffect, useState } from "react";

export enum InputFieldSize {
  Small,
  Large,
}

interface Props {
  value: any;
  onChange: (newValue: any) => void;
  onFocus?: () => void;

  leftIcon?: any;
  size?: InputFieldSize;

  unit?: string;
  unitOptions?: string[];
  onUnitChange?: (newUnit: string) => void;

  inputType: string;
  allowChanges: boolean;

  // Controls whether the onChange is called immediately after the internal value changes or on change of focus blur.
  instantChanges?: boolean;

  // Optional -> to clean input based on requirements
  cleanInput?: (newValue: string) => string;

  placeholder?: string;

  ariaLabel?: string;
}

const InputField: React.FC<Props> = React.memo((props) => {
  // Used to delay sending the change to the backend
  const [internalInput, setInternalInput] = useState(props.value);

  useEffect(() => {
    setInternalInput(props.value);
  }, [props.value]);

  let menu = null;
  let inputHeight = props.size === InputFieldSize.Large ? "34px" : "22px";
  let inputWidth =
    props.size === InputFieldSize.Large ? null : props.unit ? "85px" : "75px";

  if (props.unitOptions) {
    // @ts-expect-error TS2322
    menu = (
      <Menu
        onSelect={(info: SelectInfo) => {
          // @ts-expect-error TS2722
          props.onUnitChange(info.key);
        }}
        className="drop-menu"
      >
        {props.unitOptions.map((unit) => {
          return <MenuItem key={unit}>{unit}</MenuItem>;
        })}
      </Menu>
    );
  }

  const onChange = (e: any) => {
    let value = e.target.value;
    if (props.inputType === "number" && value) {
      value = value.replace(/[^0-9\.]/g, "");
    }

    if (props.cleanInput) {
      value = props.cleanInput(value);
    }

    setInternalInput(value);

    if (props.instantChanges) {
      props.onChange(value);
    }
  };

  const onBlur = (e: any) => {
    if (internalInput === props.value) return;

    props.onChange(internalInput);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();

      // Remove focus from the current input field
      event.currentTarget.blur();
    }
  };

  return (
    <div
      className={`input-field`}
      style={{
        // @ts-expect-error TS2322
        maxWidth: inputWidth,
        height: inputHeight,
      }}
    >
      {props.leftIcon && (
        <div
          className={`input-field-left-icon ${
            props.size === InputFieldSize.Large ? "large-input-icon" : ""
          }`}
        >
          {props.leftIcon}
        </div>
      )}
      <input
        size={5}
        className={`input-field-input ${props.leftIcon ? "with-icon" : ""}`}
        type={"text"}
        value={internalInput}
        onChange={onChange}
        disabled={!props.allowChanges}
        placeholder={props.placeholder}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onFocus={() => {
          if (props.onFocus) {
            props.onFocus();
          }
        }}
        aria-label={props.ariaLabel}
        style={{
          fontSize: "revert",
        }}
      />
      {props.unit && (
        <div className={"select-wrapper"}>
          <Dropdown
            trigger={["click"]}
            // @ts-expect-error TS2322
            overlay={props.allowChanges ? menu : null}
          >
            <button
              className={"select-button"}
              style={{
                cursor: props.allowChanges ? "pointer" : "default",
                fontSize: "revert",
              }}
            >
              {props.unit}
            </button>
          </Dropdown>
        </div>
      )}
    </div>
  );
});

export default InputField;
